import React, { useEffect, useRef, useState } from 'react';

export default function ReviewsFeed() {
  const sectionRef = useRef(null);
  const [shouldLoad, setShouldLoad] = useState(false);

  useEffect(() => {
    const section = sectionRef.current;
    if (!section) return undefined;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;
        setShouldLoad(true);
        observer.disconnect();
      },
      { rootMargin: '500px 0px' }
    );

    observer.observe(section);
    return () => observer.disconnect();
  }, []);

  useEffect(() => {
    if (!shouldLoad) return undefined;

    const existingScript = document.querySelector(
      'script[src="https://js.feedspace.io/v1/embed/embed.min.js"]'
    );

    if (existingScript) return undefined;

    const script = document.createElement('script');
    script.src = 'https://js.feedspace.io/v1/embed/embed.min.js';
    script.async = true;
    script.type = 'text/javascript';
    document.body.appendChild(script);

    return () => {
      if (document.body.contains(script)) document.body.removeChild(script);
    };
  }, [shouldLoad]);

  return (
    <section
      ref={sectionRef}
      className="w-full bg-white py-12 md:py-24 px-5 md:px-12 border-t-2 border-black"
    >
      <div className="max-w-4xl mx-auto text-center mb-10 md:mb-16">
        <h2 className="text-black text-2xl sm:text-3xl md:text-5xl lg:text-6xl font-black tracking-tight leading-tight">
          What Our Clients Say.
        </h2>
      </div>
      <div className="max-w-4xl mx-auto w-full overflow-hidden">
        {shouldLoad && (
          <div
            className="feedspace-embed"
            data-id="3c3adb36-43df-445a-b9d1-cc94b4074477"
          />
        )}
      </div>
    </section>
  );
}